import { Controller } from '../const'
import styles from './Speakers.module.css'
import { App } from '../App'

export class SpeakersController implements Controller {
  private items: HTMLElement[]

  constructor(
    private readonly node: HTMLElement,
    private readonly app: App,
  ) {
    this.onClick = this.onClick.bind(this)
    this.items = Array.from(this.node.querySelectorAll(`.${styles.Item}`) as NodeListOf<HTMLElement>)
    this.items.forEach((item) => item.addEventListener('click', this.onClick))
  }

  onClick(event: MouseEvent) {
    this.items.forEach((item) => {
      if (item === event.currentTarget) {
        if (item.classList.contains(styles.Open)) {
          item.classList.remove(styles.Open)
          this.app.stageController?.setConfig(null)
        } else {
          item.classList.add(styles.Open)
          try {
            const config = item.dataset.config ? JSON.parse(decodeURI(item.dataset.config as string)) : null
            if (config) {
              this.app.stageController?.setConfig(config)
            }
          } catch (error) {
            console.warn(error)
          }
        }
      } else {
        item.classList.remove(styles.Open)
      }
    })
  }

  dispose() {
    this.items.forEach((item) => item.removeEventListener('click', this.onClick))
  }
}
